import React from 'react';
import './scss/header.scss';
import Appbar from '../Appbar/Appbar'
import { HeaderText } from '../../styledcomponents/HeaderText/HeaderText'

import { Button } from '../../styledcomponents/Button/Button'
import { Link, animateScroll as scroll } from "react-scroll";


// C .65 .85, .35 .8, 0 1

const Header = (props) => {


    return (
        <div>


            <Appbar />

            <div className="header" id="home">
                <div className="header__container">

                    <div className="header__left-container">
                        <div className="header__heading" >
                            <div className="header__fname">
                                <HeaderText>
                                    <span>Muhammad</span>
                                </HeaderText>
                            </div>

                            <div className="header__sname">
                                <HeaderText>
                                    <span>Salim</span>
                                </HeaderText>
                            </div>

                            <div className="header__lname">
                                <HeaderText>
                                    <span>Zakari</span>
                                </HeaderText>
                            </div>

                            <p className="header__text">
                                <span>&nbsp;</span>
                   Frontend developer
                </p>

                            
                                <Button className="header__button-box" href="#about">
                                    Know more &rarr;
                                </Button>

                        </div>



                        </div>





                        <svg width="0" height="0">
                            
                        <defs>
                                <clipPath id="myCurve" clipPathUnits="objectBoundingBox">
                                    <path
                                        d="M 0,1
									L 0,0
									L 1,0
                                    L 1,1
                                    C .1 .7, .2 1, 0 1									
									Z"
                                    />

                                </clipPath>
                               


                            </defs>
                        </svg>


{/* 
                        <div className="header__right-container">
                            <img src={require("../../img/gravatar.jpg")} alt="Muhammad Salim Zakari" className="header__image" />
                        </div> */}

                    </div>



                </div>

            </div>
    )
}

export default Header;